'use client'
import React from 'react';
import { UserData, SignOut } from '@/auth';
import { CommonModal } from '@/components';

//This component is responsible for managing which modal will be displayed at each moment using a step system. For each step, it shows a different modal, and the step changes with the setStep state.
//This function is used to save states and make the code more readable.
const AuthSwitch = ({ setAuthVisible, authVisible, userData }) => {

  //State to change the modal
  const { open, step } = authVisible;

  let component = <></>;

  switch (step) {
    case 2: component = <UserData userData={userData} setAuthVisible={setAuthVisible} />
      break;
    case 3: component = <SignOut setAuthVisible={setAuthVisible} />
      break;
    default: component = <UserData userData={userData} setAuthVisible={setAuthVisible} />
      break;
  }

  return (
    <CommonModal open={open} setOpen={() => setAuthVisible({ open: false, step: null })}>
      {authVisible.open && component}
    </CommonModal>
  );
}

export default AuthSwitch;